import { ApplicationStage } from '../../../api/types';
import ListPageInner from '../../shared/ApplicationListPage/ListPageInner';

const MobilityBookingListPage = () => {
    const namespace = 'mobilityList';
    const stage = ApplicationStage.Mobility;

    return <ListPageInner namespace={namespace} stage={stage} />;
};

export default MobilityBookingListPage;
